.info-icon-wrap {
  cursor: pointer;
  &:hover {
    svg {
      path {
        fill: var(--green-dark);
      }
    }
  }
}
.info-icon-wrap.active {
  border-radius: 50%;
  box-shadow: 0 0 0 0 var(--gray-white), 0 0 0 2px var(--blue-dark);
}
.ugc-tooltip-open {
  .info-icon-wrap {
    border-radius: 50%;
    box-shadow: 0 0 0 0 var(--gray-white), 0 0 0 2px var(--blue-dark);
  }
}
